import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import TitleComponent from "../../components/TitleComponent";
import { getWeek, capitalize } from "../../lib/helper";
import { setProductKey } from "../../actions/session";
import { Link } from "react-router-dom";
import api from "../../api";
import config from "../../config";
import isEmpty from "lodash.isempty";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Select from "react-select";
import Loader from "../../components/LoaderComponent";
import useTranslation from "../../i18n/useTranslation";
import { formatWeekday } from "../../i18n/dates";

function AnimationScheduler(props) {
   const { t, locale } = useTranslation();
   const dateFormat = config.get("dateFormat");

   const [weekDays, setWeekDays] = useState([]);
   const [productKey, setProductKey] = useState(props.session.selectedProductKey);
   const [productKeyOptions, setProductKeyOptions] = useState([]);
   const [dataFetching, setDataFetching] = useState(true);
   const [animationScheduler, setAnimationScheduler] = useState({
      kodProduktu: "",
      data: "",
      dzienWiodacy: "",
      hotelAnimacje: []
   });

   useEffect(() => {
      api.getAnimationSchedule(productKey.value, "2019-10-29")
         .then((resp) => {
            setAnimationScheduler(resp.data);
            setWeekDays(getWeek(resp.data.dzienWiodacy));
         })
         .finally(() => setDataFetching(false));
      //eslint-disable-next-line
   }, []);

   useEffect(() => {
      const options = props.session.kodyProduktow.map((key) => ({ value: key, label: key }));
      setProductKeyOptions(options);
      if (isEmpty(props.session.selectedProductKey)) {
         setProductKey(options[0]);
      } else {
         setProductKey(props.session.selectedProductKey);
      }
      //eslint-disable-next-line
   }, [props.session.kodyProduktow]);

   useEffect(() => {
      setDataFetching(true);
      if (!productKey) return;
      props.setProductKey(productKey);
      api.getAnimationSchedule(productKey.value, "2019-10-29")
         .then((resp) => {
            setAnimationScheduler(resp.data);
            setWeekDays(getWeek(resp.data.dzienWiodacy));
         })
         .finally(() => setDataFetching(false));
      //eslint-disable-next-line
   }, [productKey]);

   const tooltip = (text) => <Tooltip id="tooltip">{text}</Tooltip>;

   const renderAnimations = (animations, day) => {
      if (animations.length === 0) return;
      const formattedDate = day.format(dateFormat);
      return animations.map((animation) => {
         if (animation.data === formattedDate)
            return (
               <OverlayTrigger placement="top" overlay={tooltip(animation.dane.uwagi)}>
                  <p className="text-truncate position-relative" style={{ zIndex: 2 }}>
                     {animation.dane.uwagi}
                  </p>
               </OverlayTrigger>
            );
         return false;
      });
   };

   return (
      <div className="hotels__slide">
         <TitleComponent className="section_title--width-unset">
            {t("animations.title")}
         </TitleComponent>
         <Loader show={dataFetching} />
         <div className="scheduler__container table-responsive animation-schedule">
            <table className={`scheduler__table ${!productKey && "display_hidden"}`}>
               <thead>
                  <tr>
                     <th className="product-key">
                        <Select
                           value={productKey}
                           options={productKeyOptions}
                           onChange={(option) => setProductKey(option)}
                           placeholder={t("common.selectDestination")}
                           isClearable={false}
                           maxMenuHeight={200}
                           classNamePrefix="Select"
                           className="Select"
                           components={{
                              IndicatorSeparator: () => null
                           }}
                        />
                     </th>
                     {weekDays.map((day) => {
                        return <th key={`header-${day}`}>{capitalize(formatWeekday(day, locale))}</th>;
                     })}
                  </tr>
               </thead>
               <tbody>
                  {animationScheduler.hotelAnimacje.map((hotel) => {
                     return (
                        <tr key={hotel.id}>
                           <td className="text-nowrap">
                              <OverlayTrigger placement="top" overlay={tooltip(hotel.nazwa)}>
                                 <p
                                    className="text-truncate position-relative"
                                    style={{ zIndex: 2 }}
                                 >
                                    {hotel.nazwa}
                                 </p>
                              </OverlayTrigger>
                           </td>
                           {weekDays.map((day) => {
                              return (
                                 <td key={`${day}-${hotel.id}`} className="tasks-container">
                                    <Link
                                       className="add-task-link"
                                       to={{
                                          pathname: "/animation-scheduler/new",
                                          state: {
                                             animations: hotel.Animacje.filter(
                                                (animation) =>
                                                   animation.data === day.format(dateFormat)
                                             ),
                                             hotel: hotel.nazwa,
                                             hotelId: hotel.id,
                                             day: day.format(),
                                             productKey,
                                             prevPath: props.history.location.pathname
                                          }
                                       }}
                                    >
                                       <div style={{ margin: 15 }}>
                                          {renderAnimations(hotel.Animacje, day)}
                                       </div>
                                    </Link>
                                 </td>
                              );
                           })}
                        </tr>
                     );
                  })}
               </tbody>
            </table>
         </div>
      </div>
   );
}

export default connect(
   (state) => ({
      session: state.session
   }),
   { setProductKey }
)(AnimationScheduler);
